import React from 'react'
import classnames from 'classnames'
import firebase from 'firebase/app'
import Button from '../Button'
import S from './Login.module.css'
import 'firebase/auth'
import AccountUtil from '../../util/AccountUtil'
import WindowUtil from '../../../util/WindowUtil' // eslint-disable-line import/no-unresolved, import/extensions

const PageAction = {
  SHOW_FORM : 'SF',
  TRY_CREATE : 'TC',
}

const FieldKey = {
  FIRST_NAME : 'sk.firstName',
  LAST_NAME : 'sk.lastName',
  EMAIL : 'sk.email',
  ACCEPT_TAC : 'sk.acceptTac',
  READ_TAC : 'sk.readTac',
}

class NewUser extends React.Component {

  constructor( props ) {
    super( props ) // props = { setLoading }
    this._isMounted = false;
    this.state = {
      firstName : this.readValue( FieldKey.FIRST_NAME ) || '',
      lastName : this.readValue( FieldKey.LAST_NAME ) || '',
      email : this.readValue( FieldKey.EMAIL ) || '',
      password : '',
      confirmation : '',
      readTac : this.readValue( FieldKey.READ_TAC ) || false,
      acceptTac : this.readValue( FieldKey.ACCEPT_TAC ) || false,
      action : PageAction.SHOW_FORM,
      errorCode : undefined,
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.focusInit();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  focusInit = () => {
    const { firstName, lastName, email } = this.state;
    if ( !firstName ) {
      this.firstNameInput.focus()
    } else if ( !lastName ) {
      this.lastNameInput.focus()
    } else if ( !email ) {
      this.emailInput.focus()
    } else {
      this.passwordInput.focus()
    }

  }

  updateDisplayName = ( name ) => firebase.auth().currentUser.updateProfile( { displayName : name } ).catch( ( e ) => {
    console.error( 'Error updating user displayName', e );
  } ).then( () => {
    console.log( 'User.displayName set' );
    return null;
  } )

  doCreateUser = async () => {
    const { firstName, lastName, email, password } = this.state
    const { creatingNewUser, userCreated, setLoading } = this.props;

    console.log( 'Creating user for', email );
    try {
      creatingNewUser();
      await firebase.auth().createUserWithEmailAndPassword( email, password );
      console.log( `User created for ${email}!` );
      await this.updateDisplayName( `${firstName} ${lastName}` );
      await AccountUtil.sendEmailVerification()
      // await AccountUtil.signOut();
      userCreated( email );
      if ( this._isMounted ) {
        this.setState( { action : PageAction.SHOW_FORM }, this.clearCache );
      }
    } catch ( e ) {
      console.error( 'Error creating user for', email );
      this.setState( { errorCode : e.code } );
    } finally {
      setLoading( false );
    }
  }

  createUser = () => {
    const { setLoading } = this.props;
    const { password, confirmation } = this.state
    if ( this.isValid() ) {
      setLoading( true, 'Creating new user...' )
      this.setState( { errorCode : undefined, action : PageAction.TRY_CREATE }, this.doCreateUser )
    } else if ( password !== confirmation ) {
      this.setState( { errorCode : 'validation/password-mismatch' } )
    } else {
      this.setState( { errorCode : 'validation/missing-info' } )
    }
  }

  cacheValue = ( key, value ) => {
    window.localStorage.setItem( key, JSON.stringify( value ) )
  }

  readValue = ( key ) => {
    try {
      return JSON.parse( window.localStorage.getItem( key ) )
    } catch ( e ) {
      return null
    }
  }

  clearCache = () => {
    window.localStorage.removeItem( FieldKey.FIRST_NAME )
    window.localStorage.removeItem( FieldKey.LAST_NAME )
    window.localStorage.removeItem( FieldKey.EMAIL )
    window.localStorage.removeItem( FieldKey.ACCEPT_TAC )
    window.localStorage.removeItem( FieldKey.READ_TAC )
  }

  onChangeFirstName = ( evt ) => {
    const firstName = evt.target.value
    this.setState( { firstName, errorCode : undefined },
      () => this.cacheValue( FieldKey.FIRST_NAME, firstName ) )
  }

  onChangeLastName = ( evt ) => {
    const lastName = evt.target.value
    this.setState( { lastName, errorCode : undefined },
      () => this.cacheValue( FieldKey.LAST_NAME, lastName ) )
  }

  onChangeEmail = ( evt ) => {
    const email = evt.target.value
    this.setState( { email, errorCode : undefined },
      () => this.cacheValue( FieldKey.EMAIL, email ) )
  }

  onChangePassword = ( evt ) => {
    this.setState( { password : evt.target.value, errorCode : undefined } )
  }

  onChangeConfirimation = ( evt ) => {
    this.setState( { confirmation : evt.target.value, errorCode : undefined } )
  }

  onChangeAccept = ( evt ) => {
    const acceptTac = evt.target.checked
    this.setState( { acceptTac, errorCode : undefined },
      () => this.cacheValue( FieldKey.ACCEPT_TAC, acceptTac ) )
  }

  onClickTac = ( evt ) => {
    WindowUtil.openWindow( evt.target.href )
    this.setState( { readTac : true, errorCode : undefined },
      () => this.cacheValue( FieldKey.READ_TAC, true ) )
  }

  getErrorDiv = () => {
    const { errorCode } = this.state;
    let text = '';
    if ( errorCode ) {
      switch ( errorCode ) {
        case 'auth/invalid-email':
          text = 'Error: Invalid email address';
          break;
        case 'auth/email-already-in-use':
          text = 'Error: A user already exists with that email address';
          break;
        case 'auth/weak-password':
          text = 'Error: Password is too weak';
          break;
        case 'validation/password-mismatch':
          text = 'Error: Passwords do not match';
          break;
        case 'validation/missing-info':
          text = 'Error: All fields are required';
          break;
        default:
          text = 'Error: Invalid email/password';
          break;
      }
    }
    let classes = classnames( S.inputRow, S.message );
    if ( text.length > 0 ) {
      classes = classnames( S.inputRow, S.message, S.error );
    }

    return (
      <div className={classes}>
        {text}
      </div>
    );
  }

  isValid = () => {
    const {
      firstName,
      lastName,
      email,
      password,
      confirmation,
      acceptTac,
    } = this.state
    return firstName && lastName && email && password && confirmation === password && acceptTac;
  }

  render() {
    const {
      firstName,
      lastName,
      email,
      password,
      confirmation,
      action,
      readTac,
      acceptTac,
    } = this.state

    return (
      <div>
        {this.getErrorDiv()}
        <div className={classnames( S.inputRow, S.nameRow )}>
          <div>
            <label htmlFor="txtFirstName">
              First Name
            </label>
            <input
              id="txtFirstName"
              className={S.input}
              type="text"
              onChange={this.onChangeFirstName}
              value={firstName}
              title={firstName ? '' : 'Enter your first name'}
              disabled={action !== PageAction.SHOW_FORM}
              ref={( ref ) => { this.firstNameInput = ref }}
            />
          </div>
          <div>
            <label htmlFor="txtLastName">
              Last Name
            </label>
            <input
              id="txtLastName"
              className={S.input}
              type="text"
              onChange={this.onChangeLastName}
              value={lastName}
              title={lastName ? '' : 'Enter your last name'}
              disabled={action !== PageAction.SHOW_FORM}
              ref={( ref ) => { this.lastNameInput = ref }}
            />
          </div>
        </div>
        <div className={S.inputRow}>
          <label htmlFor="txtEmail" className={S.label}>
            Email
          </label>
          <input
            id="txtEmail"
            className={S.input}
            type="text"
            onChange={this.onChangeEmail}
            value={email}
            title={email ? '' : 'Enter your email'}
            disabled={action !== PageAction.SHOW_FORM}
            ref={( ref ) => { this.emailInput = ref }}
          />
        </div>
        <div className={S.inputRowHorizontal}>
          <input
            id="chkAccept"
            className={S.input}
            type="checkbox"
            onChange={this.onChangeAccept}
            title={readTac ? 'Check to accept the Terms and Conditions' : 'Please read the Terms and Conditions by clicking the link'}
            disabled={!readTac}
            checked={acceptTac}
          />
          <label htmlFor="chkAccept">
            Read the&nbsp;
            <a
              href="https://static1.squarespace.com/static/609ae7562013d65983081424/t/60d7cc89230d4a7c1cc18fbf/1624755337403/Script+Keeper+Terms+and+Conditions.pdf"
              onClick={this.onClickTac}
            >
              Terms and Conditions
            </a>
            &nbsp;by clicking the link.
            <br />
            Check the box to accept the Terms and Conditions.
          </label>
        </div>
        <div className={S.inputRow}>
          <label htmlFor="pwdPassword" className={S.label}>
            Password
          </label>
          <input
            id="pwdPassword"
            className={S.input}
            type="password"
            onChange={this.onChangePassword}
            value={password}
            title={password ? '' : 'Enter your password'}
            disabled={action !== PageAction.SHOW_FORM || !acceptTac}
            ref={( ref ) => { this.passwordInput = ref }}
          />
        </div>
        <div className={S.inputRow}>
          <label htmlFor="pwdConfirm" className={S.label}>
            Confirm Password
          </label>
          <input
            id="pwdConfirm"
            className={S.input}
            type="password"
            onChange={this.onChangeConfirimation}
            value={confirmation}
            title={password ? '' : 'Confirm your password'}
            disabled={action !== PageAction.SHOW_FORM || !acceptTac}
          />
        </div>
        <div className={S.buttons}>
          <Button
            scheme="primary"
            onClick={this.createUser}
            disabled={action !== PageAction.SHOW_FORM && !this.isValid()}
            title={this.isValid() ? 'Create New User with given email and password.' : 'Enter your name, email address, a password and accept the Terms and Conditions'}
          >
            Create New User
          </Button>
        </div>
      </div>
    );
  }

}

/** Wrap it */
export default NewUser
